<template>
  <div class="transform-tools">
    <div class="mode-options">
      <button type="button" :disabled="disabled" :class="{ active: mode === 'resize' }"
        :aria-pressed="mode === 'resize'" @click="$emit('update-mode', 'resize')">{{ $t('editor.resizeMode') }}</button>
      <button type="button" :disabled="disabled" :class="{ active: mode === 'perspective' }"
        :aria-pressed="mode === 'perspective'" @click="$emit('update-mode', 'perspective')">{{ $t('editor.perspectiveMode') }}</button>
    </div>
    <label v-if="mode === 'resize'" class="ratio-option">
      <input type="checkbox" :checked="lockAspect" :disabled="disabled"
        @change="$emit('update-lock', $event.target.checked)" />
      <span>{{ $t('editor.preserveProportions') }}</span>
    </label>
    <button v-else type="button" class="reset-button" :disabled="disabled || !hasPerspective"
      @click="$emit('reset')">{{ $t('editor.resetPerspective') }}</button>
  </div>
</template>

<script>
export default {
  name: 'TransformTools',
  props: {
    mode: { type: String, default: 'resize' },
    lockAspect: { type: Boolean, default: true },
    hasPerspective: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ['update-mode', 'update-lock', 'reset']
};
</script>

<style scoped>
.transform-tools { display: grid; gap: 10px; }
.mode-options { display: grid; grid-template-columns: 1fr 1fr; gap: 4px; }
.mode-options button, .reset-button {
  padding: 8px 4px;
  min-height: 34px;
  font: inherit;
  font-size: 11px;
  border: 1px solid #e4e8ee;
  border-radius: 6px;
  color: #506378;
  background: #fff;
  cursor: pointer;
}
.mode-options button.active { background: #eaf2fa; border-color: #7f9db7; color: #304d65; }
.ratio-option { display: flex; align-items: center; gap: 5px; font-size: 11px; color: #506378; cursor: pointer; }
.ratio-option input { margin: 0; accent-color: #55768f; }
button:disabled { opacity: 0.45; cursor: not-allowed; }
button:focus-visible { outline: 2px solid #55768f; outline-offset: 2px; }
@media (max-width: 768px) {
  .mode-options button, .reset-button { min-height: 44px; font-size: 14px; }
  .ratio-option { min-height: 44px; font-size: 14px; gap: 9px; }
}
</style>